<div class="ds-header-pagination">
  <i
    class="ds-header-pagination__arrow atn-icon atn-long-left"
    [ngClass]="{
      'ds-header-pagination__arrow--disabled': leftArrowDisabledSg(),
    }"
    (click)="onPreviousHandler()"
  ></i>
  <div class="ds-header-pagination__numbers">
    <span>{{ currentPageSg() }}</span>
    <span>/</span>
    <span>{{ totalPagesSg() }}</span>
  </div>
  <i
    class="ds-header-pagination__arrow atn-icon atn-long-right"
    [ngClass]="{
      'ds-header-pagination__arrow--disabled': rightArrowDisabledSg(),
    }"
    (click)="onNextPageHandler()"
  ></i>
</div>
